import { Daigaku } from 'src/app/models/daigaku';

export class DaigakuUtil {
  static getDisplayDaigakuName(daigaku: Daigaku): string {
    return daigaku.daigakuName + (daigaku.daigakuSubName ? `（${daigaku.daigakuSubName}）` : '');
  }

  static getDaigakuByDaigakuCode(daigakus: Daigaku[], daigakuCode: string): Daigaku {
    return daigakus.find(daigaku => daigaku.daigakuCode === daigakuCode);
  }
}
